"use strict";

// 広告流入ごとの電話番号割当。
// 割当の正本は Xserver の MySQL とし、sessionStorage は同一タブ内での表示ちらつき防止に使う。
(function () {
  var SESSION_KEY = "tel_tracking_session_id";
  var ASSIGNMENT_KEY = "tel_tracking_assignment";
  var ASSIGNMENT_ENDPOINT = "/api/phone-assignment.php";
  var REQUEST_TIMEOUT_MS = 4000;
  var FALLBACK_PHONE_NUMBER = "0120212082";
  var MOBILE_MEDIA_QUERY = "(max-width: 767px)";

  if (
    !document.querySelector(
      "[data-tracking-phone-link], [data-tracking-phone-text], [data-tracking-phone-copy]"
    )
  ) {
    return;
  }

  function getSessionStorage() {
    try {
      var storage = window.sessionStorage;
      var testKey = "__tel_tracking_test__";
      storage.setItem(testKey, "1");
      storage.removeItem(testKey);
      return storage;
    } catch (_error) {
      return null;
    }
  }

  function createSessionId() {
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      return window.crypto.randomUUID().replace(/-/g, "");
    }
    if (window.crypto && typeof window.crypto.getRandomValues === "function") {
      var bytes = new Uint8Array(16);
      window.crypto.getRandomValues(bytes);
      return Array.prototype.map
        .call(bytes, function (value) {
          return value.toString(16).padStart(2, "0");
        })
        .join("");
    }
    return (
      Date.now().toString(36) +
      Math.random().toString(36).slice(2) +
      Math.random().toString(36).slice(2)
    );
  }

  function getSessionId(storage) {
    var current = storage ? storage.getItem(SESSION_KEY) : "";
    if (current && /^[a-zA-Z0-9_-]{20,128}$/.test(current)) {
      return current;
    }
    var created = createSessionId();
    if (storage) {
      storage.setItem(SESSION_KEY, created);
    }
    return created;
  }

  function getQueryParam(name) {
    try {
      return (new URLSearchParams(window.location.search).get(name) || "").trim();
    } catch (_error) {
      return "";
    }
  }

  function getGclidFromUrl() {
    return getQueryParam("gclid");
  }

  function getHiddenValue(name) {
    var input = document.querySelector('input[name="' + name + '"]');
    return input && input.value ? input.value.trim() : "";
  }

  function getClickId(name, hiddenName) {
    // 電話割当は「今開いているLPの値」を優先する。
    // first-touch cookie 由来の hidden 値で古いIDが残るのを避ける。
    var fromUrl = getQueryParam(name);
    if (fromUrl) {
      return fromUrl;
    }
    return getHiddenValue(hiddenName);
  }

  function getGclid() {
    return getClickId("gclid", "GCLID");
  }

  function getMeasurementPayload() {
    return {
      gbraid: getClickId("gbraid", "GBRAID"),
      wbraid: getClickId("wbraid", "WBRAID"),
      user_agent: getHiddenValue("USER_AGENT") || (navigator.userAgent || ""),
      session_attributes: getHiddenValue("SESSION_ATTRIBUTES"),
    };
  }

  function normalizeAssignment(value) {
    if (!value || typeof value !== "object") return null;
    var phoneNumber = String(value.phone_number || "").replace(/\D/g, "");
    var displayNumber = String(value.display_number || "");
    if (!/^0\d{9,10}$/.test(phoneNumber)) return null;
    if (!/^[0-9-]{10,15}$/.test(displayNumber)) {
      displayNumber =
        phoneNumber.indexOf("0120") === 0 && phoneNumber.length === 10
          ? phoneNumber.replace(/^(\d{4})(\d{3})(\d{3})$/, "$1-$2-$3")
          : phoneNumber;
    }
    return {
      phone_number: phoneNumber,
      display_number: displayNumber,
      expires_at: String(value.expires_at || ""),
      trackable: value.trackable !== false,
      fallback_reason: String(value.fallback_reason || ""),
    };
  }

  function isAssignmentActive(assignment) {
    if (!assignment || assignment.trackable === false || !assignment.expires_at) {
      return false;
    }
    var expiresAt = Date.parse(assignment.expires_at);
    return Number.isFinite(expiresAt) && expiresAt > Date.now();
  }

  function applyAssignment(assignment) {
    if (!assignment) return;
    document.querySelectorAll("[data-tracking-phone-link]").forEach(function (link) {
      link.setAttribute("href", "tel:" + assignment.phone_number);
    });
    document.querySelectorAll("[data-tracking-phone-text]").forEach(function (element) {
      element.textContent = assignment.display_number;
    });
    document.querySelectorAll("[data-tracking-phone-copy]").forEach(function (element) {
      element.setAttribute("data-tel-pc-copy", assignment.display_number);
    });
  }

  function readCachedAssignment(storage) {
    if (!storage) return null;
    try {
      return normalizeAssignment(JSON.parse(storage.getItem(ASSIGNMENT_KEY) || "null"));
    } catch (_error) {
      return null;
    }
  }

  function saveCachedAssignment(storage, assignment) {
    if (!storage) return;
    try {
      storage.setItem(ASSIGNMENT_KEY, JSON.stringify(assignment));
    } catch (_error) {
      // sessionStorage 容量不足時も電話導線自体は維持する。
    }
  }

  function requestAssignment(sessionId) {
    var controller = typeof AbortController === "function" ? new AbortController() : null;
    var timeoutId = controller
      ? window.setTimeout(function () {
          controller.abort();
        }, REQUEST_TIMEOUT_MS)
      : null;

    var measurement = getMeasurementPayload();
    return fetch(ASSIGNMENT_ENDPOINT, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        session_id: sessionId,
        gclid: getGclid(),
        landing_url: window.location.href,
        gbraid: measurement.gbraid,
        wbraid: measurement.wbraid,
        user_agent: measurement.user_agent,
        session_attributes: measurement.session_attributes,
      }),
      signal: controller ? controller.signal : undefined,
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("phone assignment failed");
        }
        return response.json();
      })
      .then(function (responseBody) {
        return normalizeAssignment(responseBody && responseBody.data);
      })
      .finally(function () {
        if (timeoutId) {
          window.clearTimeout(timeoutId);
        }
      });
  }

  var storage = getSessionStorage();
  var activeAssignment = null;
  var assignmentPromise = null;

  function ensureAssignment() {
    // gclid 有無に関わらず API を呼び、サーバー側イベントログを必ず残す。
    if (activeAssignment && isAssignmentActive(activeAssignment) && getGclid()) {
      return Promise.resolve(activeAssignment);
    }

    var cachedAssignment = readCachedAssignment(storage);
    if (isAssignmentActive(cachedAssignment) && getGclid()) {
      activeAssignment = cachedAssignment;
      applyAssignment(activeAssignment);
      return Promise.resolve(activeAssignment);
    }
    if (assignmentPromise) {
      return assignmentPromise;
    }

    var sessionId = getSessionId(storage);
    assignmentPromise = requestAssignment(sessionId)
      .then(function (assignment) {
        if (!assignment) {
          assignmentPromise = null;
          return null;
        }
        activeAssignment = assignment;
        if (assignment.trackable !== false) {
          saveCachedAssignment(storage, assignment);
          applyAssignment(assignment);
        }
        return assignment;
      })
      .catch(function () {
        assignmentPromise = null;
        return null;
      });
    return assignmentPromise;
  }

  document
    .querySelectorAll('.p-modal__open-btn[data-dialog="modal1"]')
    .forEach(function (button) {
      button.addEventListener("click", ensureAssignment);
    });

  document.querySelectorAll("[data-tracking-phone-link]").forEach(function (link) {
    link.addEventListener("click", function (event) {
      if (!window.matchMedia(MOBILE_MEDIA_QUERY).matches || !assignmentPromise) {
        return;
      }
      if (activeAssignment && activeAssignment.trackable !== false) {
        return;
      }

      event.preventDefault();
      var pendingAssignment = assignmentPromise;
      pendingAssignment.then(function (assignment) {
        var phoneNumber =
          assignment && assignment.trackable !== false
            ? assignment.phone_number
            : FALLBACK_PHONE_NUMBER;
        window.location.href = "tel:" + phoneNumber;
      });
    });
  });
})();
